import axios from "axios";

const state = {
	
	codeInfo: {},

};

const actions = {

    async loadCode(context, code){
		return axios.get("/api/1/codeInfo",{params:{code:code}}).then(function(response){
			context.commit("setCode",response.data.result);

		})
	},
	
}

const mutations = {
	setCode(state,data){
		state.codeInfo = data;
	},
}

const getters = {
	codeInfo(state){
		return state.codeInfo;
	},
};
  

export default {
    state,
    actions,
    mutations,
    getters
};